// @ts-nocheck
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faXmark, 
    faSpinner,
    faCheck,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

interface ProcessingStatusModalProps {
    status: {
        is_processing: boolean;
        processing_count: number;
        queue: {
            total: number;
            completed: number;
            processing: number;
            failed: number;
        };
    };
    onClose: () => void;
}

const ProcessingStatusModal: React.FC<ProcessingStatusModalProps> = ({ status, onClose }) => {
    const progress = status.queue.total > 0 
        ? Math.round((status.queue.completed / status.queue.total) * 100)
        : 0;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">
                        Processing YouTube Videos
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <FontAwesomeIcon icon={faXmark} className="text-xl" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="mb-6">
                        <div className="flex justify-between text-sm text-gray-600 mb-2">
                            <span>Progress</span>
                            <span>{progress}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-3">
                            <div 
                                className="bg-blue-600 h-3 rounded-full transition-all duration-300"
                                style={{ width: `${progress}%` }}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="bg-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600">Total</span>
                                <span className="text-lg font-semibold">{status.queue.total}</span>
                            </div>
                        </div>
                        
                        <div className="bg-green-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600 flex items-center gap-1">
                                    <FontAwesomeIcon icon={faCheck} className="text-green-500" />
                                    Completed
                                </span>
                                <span className="text-lg font-semibold text-green-700">
                                    {status.queue.completed}
                                </span>
                            </div>
                        </div>
                        
                        <div className="bg-blue-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600 flex items-center gap-1">
                                    <FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />
                                    Processing
                                </span>
                                <span className="text-lg font-semibold text-blue-700">
                                    {status.queue.processing}
                                </span>
                            </div>
                        </div>
                        
                        <div className="bg-red-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600 flex items-center gap-1">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500" />
                                    Failed
                                </span>
                                <span className="text-lg font-semibold text-red-700">
                                    {status.queue.failed}
                                </span>
                            </div>
                        </div>
                    </div>

                    {status.is_processing && (
                        <div className="mt-4 p-3 bg-blue-50 rounded-lg flex items-center gap-3">
                            <FontAwesomeIcon 
                                icon={faSpinner} 
                                className="text-blue-600 animate-spin"
                            />
                            <span className="text-sm text-blue-700">
                                Processing videos... This may take a few minutes.
                            </span>
                        </div>
                    )}

                    {!status.is_processing && status.queue.total > 0 && (
                        <div className="mt-4 p-3 bg-green-50 rounded-lg flex items-center gap-3">
                            <FontAwesomeIcon 
                                icon={faCheck} 
                                className="text-green-600"
                            />
                            <span className="text-sm text-green-700">
                                Processing complete!
                            </span>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end px-6 py-4 border-t bg-gray-50">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProcessingStatusModal;